import LabelMap from "../../../bootstrap/types/label-map/LabelMap";
import __ from "../../i18n";


const STATUS_NEW = 'NEW';
const STATUS_ACTIVE = 'ACTIVE';
const STATUS_BANNED = 'BANNED';

const statuses = new LabelMap([
    [STATUS_NEW, __('New')],
    [STATUS_ACTIVE, __('Active')],
    [STATUS_BANNED, __('Banned')],
]);


export default statuses;

export {
    STATUS_NEW,
    STATUS_ACTIVE,
    STATUS_BANNED,
};
